/**
 * Quiz Rush campaign options schema and validation.
 * Used by the editor and game runtime to ensure question data is valid.
 *
 * Campaign options shape:
 * - timePerQuestion: number (10–60)
 * - questions: Array<QuizQuestion> (each play uses all valid questions)
 * Scoring is Kahoot-style: faster correct answers score more (50–100 pts per question).
 * - correctSound, wrongSound: string (URL or "synth:...")
 *
 * QuizQuestion:
 * - questionText: string (required)
 * - image?: string (URL, optional)
 * - optionA, optionB, optionC, optionD: string (required)
 * - correctAnswer: "A" | "B" | "C" | "D" (required)
 */

const OPTION_KEYS = ['A', 'B', 'C', 'D'];
const MIN_QUESTIONS = 1;

export function isValidQuestion(q) {
  if (!q || typeof q !== 'object') return false;
  if (typeof q.questionText !== 'string' || !q.questionText.trim()) return false;
  for (const k of OPTION_KEYS) {
    const v = q[`option${k}`];
    if (v == null || typeof v !== 'string' || !String(v).trim()) return false;
  }
  if (!OPTION_KEYS.includes(q.correctAnswer)) return false;
  return true;
}

export function getValidQuestions(questions) {
  if (!Array.isArray(questions)) return [];
  return questions.filter(isValidQuestion);
}

export function getQuizRushPublishError(options) {
  if (!options) return 'Missing options';
  const questions = options.questions;
  const questionWord = MIN_QUESTIONS === 1 ? 'question' : 'questions';
  if (!Array.isArray(questions) || questions.length < MIN_QUESTIONS) {
    return `Quiz Rush needs at least ${MIN_QUESTIONS} ${questionWord} (you have ${questions?.length ?? 0}).`;
  }
  const valid = getValidQuestions(questions);
  if (valid.length < MIN_QUESTIONS) {
    return `At least ${MIN_QUESTIONS} complete ${questionWord} required (each needs text, 4 options, and correct answer).`;
  }
  return null;
}
